import React , {useState , useEffect} from 'react';

//*MUI
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import cssClasses from "./Profile.module.css";
import Badge from '@mui/material/Badge';

//*files
import loginImage from "../../assets/images/icons/loginImage.png";
import cameraIcon from "../../assets/images/icons/cameraIcon.svg";
import Button from '../../SubComponent/Button';
import {CustomReadTextInput, CustomTextInput} from '../../SubComponent/CustomTextInput';
import { InputTextIsValid,  isCityFieldValid,  isPhoneNumberValid, isPinCodeValid, isStateFieldValid } from '../../services/Validations';
import { dismissLoader, presentLoader } from '../../services/loaderService';
import {   UpdateStudentProfile} from '../../services/examsService';
import { errorToast, successToast } from '../../services/Toast';
import { uploadFilesAWS } from '../../services/AwsBucket';
//* Import store
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import { Box } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  divContainer :{
    backgroundColor:" #FFFFFF",
    margin:"1.5rem",
  },  
}));

function Field({title , TextField}){
  return(
    <div>
       <Grid container  direction="row"
         alignItems="center"
         justifyContent="center"
         columns={16} 
          >
          <Grid item xs={8} sm={8} md={8} lg={2.5}>
          <div className={cssClasses.ContentTitle}>{title}</div>
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={5}>
          <div className={cssClasses.ButtonWrap}>
            {TextField}
                </div>
          </Grid>
          </Grid>
    </div>
  )
}


export default function Profile() {
  
  const dispatch = useDispatch();

  const [SaveProfileButtonDisable , setSaveProfileButtonDisable] = useState(true);

  const loggedInUser = useSelector((state) => state.Auth.user);
  const [changeProfile , setChangeProfile] = useState("");

  const [ProfileFields, setProfileFields] = useState({
    "Full Name" : '' ,
    phone : '' ,
    Pincode : '' ,
    Address : '' ,
    City : '' ,
    State : '',
  });
  
  const [ProfileFieldHelperText, setProfileFieldHelperText] = useState({
    "Full Name" : '' ,
    phone : '' ,
    Pincode : '' ,
    Address : '' ,
    City : '' ,
    State : '',
  });  

  const classList = useStyles();

  useEffect(() => {
    dispatch(actions.activeMenu('profile'));
  }, [])

  useEffect(() => {
    console.log("loggedInUser ===> ",loggedInUser);
    let _obj = {}
    if (loggedInUser) {
      Object.keys(ProfileFields).forEach((key) => {
        _obj[key] = loggedInUser[key]
      })
      console.log({_obj});
      setProfileFields({..._obj})
    }
  }, [loggedInUser])
  

   async function selectFile(_file) {
    if (_file && _file.type.includes("image")) {
      updateProfilePhoto(_file);
    } else {
      errorToast("Please Upload Image Only!")
    }
   }


   const KeyPressed = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  const KeyCancelPressed = (e) => {
    if (e.key === 'Enter') {
      ResetFields();
    }
  };

 async function updateProfilePhoto(_file){

      presentLoader()
      let fileObjectToUpload  = {
        name: _file.name,
        size: _file.size,
        key: process.env.REACT_APP_bucketRootKey+'/'+ loggedInUser?.docId  +'/profilePicture' +  `/profilePicture_${loggedInUser?.docId}.${_file.name.split(".").pop()}`,
        arrayBuffer: _file,
       }


       uploadFilesAWS([fileObjectToUpload], (data) => {
        if (data?.result.includes("Files Uploaded")) {
          setChangeProfile("https://exam-management.s3.ap-south-1.amazonaws.com/"+fileObjectToUpload.key)
          UpdateStudentProfile(loggedInUser?.docId , {profilePicture:"https://exam-management.s3.ap-south-1.amazonaws.com/"+fileObjectToUpload.key}).then(res=>{
            dispatch(actions.authUpdate({profilePicture:"https://exam-management.s3.ap-south-1.amazonaws.com/"+fileObjectToUpload.key}));
            successToast("Profile Picture Uploaded!")
          }).catch(err=>{
            console.log(err);
            errorToast("Something went wrong! Try Again")
          })
          dismissLoader()
        } else {
          errorToast("Something went wrong! Try again");
        }
      }, (err) => {
        console.log("err => ",err);
        dismissLoader()
        errorToast("Something went wrong! Try again");
      }, (progress) => {
        dismissLoader()
        console.log("progress => ",progress);
      }
    );

  }

  useEffect(() => {
    setSaveProfileButtonDisable(Object.keys(ProfileFields).filter(f => ProfileFields[f] !== loggedInUser[f]).length > 0)
  }, [ProfileFields])
  


  function onSubmit(){
    let _FullNameValid = InputTextIsValid(ProfileFields["Full Name"]);
    let _PhoneNoValid = isPhoneNumberValid(ProfileFields.phone);
    let _PinValid = isPinCodeValid(ProfileFields.Pincode);
    let _CityValid = isCityFieldValid(ProfileFields.City);
    let _StateValid = isStateFieldValid(ProfileFields.State);
    
    let validArray = [
      {
        key: "Full Name",
        value: ProfileFields["Full Name"],
        flag: _FullNameValid.flag
      },

      {
        key: "phone",
        value: ProfileFields.phone,
        flag: _PhoneNoValid.flag
      },

      {
        key: "Pincode",
        value: ProfileFields.Pincode,
        flag: _PinValid.flag
      },

      {
        key: "City",
        value: ProfileFields.City,
        flag: _CityValid.flag
      },

      {
        key: "State",
        value: ProfileFields.State,
        flag: _StateValid.flag
      },

      {
        key: "Address",
        value: ProfileFields.Address,
        flag : true
      },
    ]

  
    if(validArray.filter(s => s.flag === true).length === validArray.length ){  
      presentLoader()
      let postBody = {}
        validArray.filter(f=> f.flag).forEach((ele) => {
        postBody[ele.key] = ele.value;
      });

      console.log("postBody => ", postBody);

      UpdateStudentProfile(loggedInUser?.docId , postBody).then(res => {
        dispatch(actions.authUpdate(postBody));
        dismissLoader()
        successToast("Profile updated successfully!")          
      }).catch( err => {
        dismissLoader()
        errorToast("Something went wrong! Try again.")
        console.log(err);
      })
    } else {
      dismissLoader()
      errorToast("Please enter at-least one field!")
    }  
  }

  function ResetFields(){
    setProfileFields({...loggedInUser});
  }

  return (
    <div className={classList.divContainer}>
      
        <div className={cssClasses.ImgWrap}>
       <img src={loginImage} alt="colorImage" height="100%" width="100%"/>
       </div>
         <Box className={cssClasses.rowDiv} style={{marginTop : "-5rem" , padding:"0 2rem" }}>
          <Box className={cssClasses.rowDiv}>
            <Box>
            <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          value={changeProfile}
          badgeContent={
              <button
                className={cssClasses.photo}
                onClick={()=>{
                  document.getElementById("ProfileImageInputRef").click()
                }}
              >
              <input hidden type="file" id={"ProfileImageInputRef"}  onChange={(e) => { selectFile(e.target.files[0]) }} accept="image/*"/>
             <div className={cssClasses.IconWrapper}> <img src={cameraIcon} alt={""}  /></div>
             </button>   
        }
      >
        <Avatar
         alt={""}
         src={loggedInUser?.profilePicture}
         sx={{ width: 150, height: 150 }}   
        />
          </Badge>
            </Box>
          <Box style={{marginLeft:"2rem" , marginTop:"3rem"}}>
          <p className={cssClasses.NameTitle}>{loggedInUser ? loggedInUser['Full Name'] : ""}</p>
          <p className={cssClasses.subTitle}>Update your photo and personal details</p>
          </Box>
          </Box>

          <div className={cssClasses.rowDiv} >
            <div className={cssClasses.ButtonWrap} style={{marginTop:"3rem"}}>
            <Button
             style={{ color: "#7F56D9", backgroundColor: "#ffffff" }}
             btnName={"Cancel"}
             clicked={()=> ResetFields()}
             handleKeypress={KeyCancelPressed}/> 
            </div>
          
          <div className={cssClasses.ButtonWrap} style={{marginTop:"3rem"}}>
             <Button
             style={{ color: "#ffffff", backgroundColor: "#7F56D9" }}
             btnName={"Save"}
             clicked={()=> onSubmit()}
             handleKeypress={KeyPressed}
             disable={!SaveProfileButtonDisable}
              /> 
          </div>
          </div>
         </Box>
   
        <div className={cssClasses.ContentDiv}>
            <Field
             title={'Full Name'}
             TextField={
             <CustomTextInput
              name={'Enter full name'}
              inputType={'text'}
              value={ProfileFields["Full Name"]}
              onChangeValue={(_value) => {
                let pre = Object.assign({}, ProfileFields);
                pre["Full Name"] = _value;
                setProfileFields({ ...pre });
                setProfileFieldHelperText((pre) => {
                  pre["Full Name"]= InputTextIsValid(_value).helperText;
                  return { ...pre };
                })
              }}
              helperText={ProfileFieldHelperText["Full Name"]}
            />} />


            <Field
             title={'Email address'}
             TextField={ 
             <CustomReadTextInput
             value={loggedInUser?.email}/>} 
            />

            <Field
            title={'Mobile Number'}
             TextField={    
             <CustomTextInput
              name={'Enter mobile number'}
              inputType={'tel'}
              value={ProfileFields.phone }
              onChangeValue={(_value) => {
                const r = new RegExp(/^\d+$/);
                if ((r.test(_value) || _value === "" ) && _value.length <= 10) {
                  let pre = Object.assign({},ProfileFields);
                  pre.phone = _value;
                  setProfileFields({ ...pre });
                  setProfileFieldHelperText((pre) => {
                    pre.phone = isPhoneNumberValid(_value).helperText;
                    // setPhone(_value);
                    return { ...pre };
                  })
                }
              }}
              helperText={ProfileFieldHelperText.phone}
            />
            } />

               <Field
                  title={'Address'}
                  TextField={<CustomTextInput
                  name={'Enter address'}
                  inputType={'text'}
                  value={ProfileFields.Address }
                  onChangeValue={(_value) => {
                      let pre = Object.assign({},ProfileFields);
                      pre.Address = _value;
                      setProfileFields({ ...pre });
                      return {...pre}
                  }
                  }
               />} />


          <Field
            title={'City'}
             TextField={<CustomTextInput
              name={'Enter city'}
              inputType={'text'}
              value={ProfileFields.City }
              onChangeValue={(_value) => {
                const e = new RegExp(/^([^0-9]*)$/);
                if (e.test(_value) || _value === "") {
                  let pre = Object.assign({}, ProfileFields);
                  pre.City = _value;
                  setProfileFields({ ...pre });
                  setProfileFieldHelperText((pre) => {
                    pre.City = isCityFieldValid(_value).helperText;
                    // setCity(_value);
                    return { ...pre };
                  })
                }
              }}
              helperText={ProfileFieldHelperText.City}
            />} />


          <Field
            title={'State'}
             TextField={ <CustomTextInput
              name={'Enter state'}
              inputType={'text'}
              value={ProfileFields.State}
              onChangeValue={(_value) => {
                const t = new RegExp(/^([^0-9]*)$/);
                if (t.test(_value) || _value === "") {
                let pre = Object.assign({}, ProfileFields);
                pre.State = _value;
                setProfileFields({ ...pre });
                setProfileFieldHelperText((pre) => {
                  pre.State = isStateFieldValid(_value).helperText;
                  // SetState(_value);
                  return { ...pre };
                })
              }
              }}
              helperText={ProfileFieldHelperText.State}
            />} />


            <Field
            title={'Pincode'}
             TextField={ <CustomTextInput
              name={'Enter pin code'}
              inputType={'text'}
              value={ProfileFields.Pincode }
              onChangeValue={(_value) => {
                const f = new RegExp(/^\d+$/);
                if ((f.test(_value) || _value === "" ) && _value.length <= 6) {
                let pre = Object.assign({}, ProfileFields);
                pre.Pincode = _value;
                setProfileFields({ ...pre });
                setProfileFieldHelperText((pre) => {
                  pre.Pincode = isPinCodeValid(_value).helperText;
                  // setPin(_value);
                  return { ...pre };
                })
              }
              }}
              helperText={ProfileFieldHelperText.Pincode}
            />} />
            
   </div>
    </div>
  );
}
